import { render, staticRenderFns } from "./RecognitionSidebar.vue?vue&type=template&id=0be02c3c&scoped=true&"
import script from "./RecognitionSidebar.vue?vue&type=script&lang=js&"
export * from "./RecognitionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionSidebar.vue?vue&type=style&index=0&id=0be02c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be02c3c",
  null
  
)

export default component.exports